import { Button, IconButton, Snackbar } from "@material-ui/core";
import { Brightness3, Brightness7 } from "@material-ui/icons";
import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useEffect, useState } from "react";
import ReactJson from "react-json-view";
import PerfectScrollbar from 'react-perfect-scrollbar';
import styled from 'styled-components';
import { postWithHeader } from "../../common";
import Files from "../../Files";
import { GradientDiv } from "../../styles/common";

interface ProgressEventType {
  loaded: number;
  total: number;
}
const HeaderSpan = styled.span`
border: 1px solid white;
    color: black;
    border-radius: 8px;
    font-weight: bold;
    font-size: 19px;
    padding: 8px;
    margin: 14px;
}
`
const HeaderDiv = styled.div`
display: flex;
    justify-content: center;
    max-height: 44vh;
    padding: 46px;
    flex-wrap: wrap;
`
interface ResponseFileUpload {
  result:[],
  message:string,
  headers:string[],
  status:string
} 

export const Home = () => {
  const [uploadError, setUploadError] = useState("");
  
  const [isUploading, setIsUploading] = useState(false);

  const [fileLoadPercentage, setFileLoadPercentage] = useState(0);
  const [response, setResponse] = useState<ResponseFileUpload | undefined>(undefined);
  const [headersFromFile, setHeadersFromFile] = useState([]);

  const onFileSelected = async () => {
    // @ts-ignore
    setErrorRows([]);
   

   
  };

  const onRemoveFile = () => {
   
    setResponse(undefined)
    setHeadersFromFile([])
    setFileLoadPercentage(0)
  };


  const onUploadFile = async (file: any) => {
   
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res: any = await postWithHeader(
        `/hello`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent: ProgressEventType) => {
            const { loaded, total } = progressEvent;
            const percent = Math.floor((loaded * 100) / total);
            setFileLoadPercentage(percent);
          },
        }
      );
      console.log("Res - ", res);
      setIsUploading(false);
      setResponse(res);
      setOpen(true);
      setHeadersFromFile(res.headers);
    } catch (error) {
      setOpen(true);
      if (error.errors) {
      }
      setIsUploading(false);
      setUploadError(error.reason || error.message);
      setResponse({result:[],headers:[],status:"error",message:error.message})
    }
  };

  useEffect(() => {
    if (response) {
      setIsUploading(false);
    }
  
  }, [response]);

  const [collapse, setCollapse] = useState(false);
  const toggleCollapse = () => {
    setCollapse(!collapse);
  };
  const [dataTypes, setDataTypes] = useState(false);
  const toggleDataTypes = () => {
    setDataTypes(!dataTypes);
  };
  const [theme, setTheme] = useState(true);
  const icon = !theme ? <Brightness7 /> : <Brightness3 />;
  const [open, setOpen] = React.useState(false);

  const handleSnackbarClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  

  return (
    <>
    {
      response && ( <Snackbar open={open} autoHideDuration={100000} onClose={handleSnackbarClose}>
<Alert onClose={handleSnackbarClose} severity={response.status==='error' ? "error" : "success"}>
<AlertTitle>{response.status==='error' ? "Error" : "Success"}</AlertTitle>
{response.status==='error' ? <><span>{response.message.split('uploaded')[0]+ ' uploaded '} </span><strong>{response.message.split('uploaded')[1].split(',')[0] }</strong> <span>{', '+ response.message.split(',')[1]}</span></>  :  response.message}
  </Alert></Snackbar>

      )
    }
      {" "}
      <GradientDiv>
      
        <Files
          isUploading={isUploading}
          onUploadFile={onUploadFile}
          onRemoveFile={onRemoveFile}
          uploadError={uploadError}
          setUploadError={setUploadError}
          fileLoadPercentage={fileLoadPercentage}
          onFileSelected={onFileSelected}
        />
      </GradientDiv>
      <br />
      <br />
      <br />
      {headersFromFile.length > 0 && (
        <>
          {" "}
          <GradientDiv style={{ overflow: "hidden" }}>
          <div><span className={'gradient1-text'} style={{fontSize:43}}>Headers</span></div>
       
            <HeaderDiv>
              {headersFromFile.map((x) => {
                return (
                  <HeaderSpan >
                    {x}
                  </HeaderSpan>
                );
              })}
            </HeaderDiv>
          </GradientDiv>
          <br />
          <br />
          <br />
        </>
      )}
      <GradientDiv style={{ overflow: "hidden" }}>
        <div><span className={'gradient1-text'} style={{fontSize:43}}>Output</span></div>
        <div style={{ display: "flex", justifyContent: "space-evenly", padding:'20px' }}>
          <Button className={'outputSecBtns'} onClick={toggleCollapse}>Collapse</Button>
          <Button className={'outputSecBtns'} onClick={toggleDataTypes}>Data Types</Button>
          <IconButton
            edge="end"
            aria-label="mode"
           className={'outputSecBtns'}  onClick={() => setTheme(!theme)}
          >
            {icon}
          </IconButton>
        </div>
<PerfectScrollbar>
  <div style={{maxHeight: "50vh"}}>
        <ReactJson
          displayDataTypes={dataTypes}
          collapseStringsAfterLength={false}
          groupArraysAfterLength={10}
          name={null}
          style={{
            textAlign: "left",
            padding: "25px",
            fontSize: "16px",
          }}
          collapsed={collapse}
          src={{result:response?.result}}
          theme={theme ? "rjv-default" : "monokai"}
        /></div></PerfectScrollbar>
      </GradientDiv>
    </>
  );
};
